import { create } from "zustand"

export const useGlobalsStore = create((set) => ({
	store: {},
	setGlobals: (newStore) =>
		set((oldStore) => ({
			store: {
				...oldStore.store,
				...newStore,
			},
		})),
}))
